import addressData from "./address";
import moment from "moment";


export default function registrationPage() {
    addressData();

    let stripe = Stripe('pk_live_51PfBDF2nYP5MLcn0fA7o3oama3LZd9tvRD4IvXUVkV6jm2bLChqrGwz8oGMRKU16HfQE29hNHLRxTYLE9MCLDwIE00XOnTndjE', {
        apiVersion: '2020-08-27'
    });
    // let stripe = Stripe('pk_test_51PfBDF2nYP5MLcn0gMxV2Lj2w8nODlH2iBUMOn5vl2oWLDBTqn5AzKm5hmqf39SWyLSQ5QaTRUG8D9k2I2ElGl4i00adnexlYp', {
    //    apiVersion: '2020-08-27'
    // });
    const appearance = {
        theme: 'flat',
        variables: {
            fontFamily: ' "Gill Sans", sans-serif',
            fontLineHeight: '1.5',
            borderRadius: '10px',
            colorBackground: '#F6F8FA',
            accessibleColorOnColorPrimary: '#262626'
        },
        rules: {
            '.Block': {
                backgroundColor: 'var(--colorBackground)',
                boxShadow: 'none',
                padding: '12px'
            },
            '.Input': {
                padding: '12px'
            },
            '.Input:disabled, .Input--invalid:disabled': {
                color: 'lightgray'
            },
            '.Tab': {
                padding: '10px 12px 8px 12px',
                border: 'none'
            },
            '.Tab:hover': {
                border: 'none',
                boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)'
            },
            '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
                border: 'none',
                backgroundColor: '#fff',
                boxShadow: '0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)'
            },
            '.Label': {
                fontWeight: '500'
            }
        }
    };

    const options = {
        appearance: appearance
    };

    const FirstName = $('#BinCleaningRegistrationForm_Form_FirstName');
    const LastName = $('#BinCleaningRegistrationForm_Form_Surname');
    const Email = $('#BinCleaningRegistrationForm_Form_Email');
    const Phone = $('#BinCleaningRegistrationForm_Form_Phone');
    const Address1 = $('#BinCleaningRegistrationForm_Form_Address_1');
    const Suburb = $('#BinCleaningRegistrationForm_Form_Suburb');
    const PostCode = $('#BinCleaningRegistrationForm_Form_PostCode');
    const City = $('#BinCleaningRegistrationForm_Form_City');
    const CollectionDay = $('#BinCleaningRegistrationForm_Form_CollectionDay');

    const ToggleButton = $('#ButtonAddressToggle');
    const ToggleButtonText = $('#ButtonAddressToggleText');
    const AutomaticAddress = $('#SearchAddressSection');
    const ManualAddress = $('#ManualAddressSection');
    const SearchAddress = $('#SearchAddress');
    const StreetAddress = $('#BinCleaningRegistrationForm_Form_Address_1');

    const TypeInput = $('#BinCleaningRegistrationForm_Form_CollectionType');
    const SubscriptionWrapper = $('#SubscriptionTypeCollection');
    const CollectionWrapper = $('#CollectionTypeCollection');
    const cleaningFrequency = $('#BinCleaningRegistrationForm_Form_CleaningFrequency');
    const automaticWebReferenceContent = $('.automatic-web-reference-content');
    const automaticTotalContent = $('.automatic-total-content');

    const formItem = $('#BinCleaningRegistrationForm_Form');
    const form = document.getElementById('BinCleaningRegistrationForm_Form');

    const paymentTypeOption = $('#BinCleaningRegistrationForm_Form_PaymentType');
    const cardSection = $('#CardSection');
    const automaticSection = $('#AutomaticSection');
    const cardNeedsValidEmail = $('#CardNeedsValidEmail');


    ToggleCard();

    paymentTypeOption.on('change',function(){
        ToggleCard();
    });

    let paymentElement;
    let elements;

    function validateEmail(){
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(Email.val())) {
            return true;
        }

        return false;
    }

    function ToggleCard(){
        cardNeedsValidEmail.addClass('d-none');
        let cardType = paymentTypeOption.val();
        let urlVar = '?email='+Email.val()+'&name='+FirstName.val()+' '+LastName.val()+'&phone='+Phone.val()+'&address_1='+Address1.val()+'&suburb='+Suburb.val()+'&postcode='+PostCode.val()+'&city='+City.val();
        if(cardType === 'Credit Card'){
            if(validateEmail()){
                cardSection.removeClass('d-none');
                fetch('/payment-intent'+urlVar, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(function(response) {
                        return response.json();
                    })
                    .then(function(data) {
                        if (data.error) {
                            console.error('Error creating PaymentIntent:', data.error);
                            return;
                        }

                        elements = stripe.elements({
                            clientSecret: data.clientSecret,
                        });

                        paymentElement = elements.create('payment');
                        paymentElement.mount('#CardSection');
                    });

                automaticSection.addClass('d-none');
                cardNeedsValidEmail.addClass('d-none');
            } else {
                cardNeedsValidEmail.removeClass('d-none');
                automaticSection.addClass('d-none');
                cardSection.addClass('d-none');
            }


        } else if(cardType === 'Automatic'){
            cardSection.addClass('d-none');
            automaticSection.removeClass('d-none');
            AutomaticData();
        } else {
            cardSection.addClass('d-none');
            automaticSection.addClass('d-none');
        }
    }

    function AutomaticData(){
        var webReference = LastName.val()+''+FirstName.val().charAt(0).toUpperCase();
        var total = totalPlusGst();
        automaticWebReferenceContent.text(webReference);
        automaticTotalContent.text(total);

    }

    function totalPlusGst() {
        let cleaningFrequency = $('#BinCleaningRegistrationForm_Form_CleaningFrequency').val();
        let cleaningType = $('#BinCleaningRegistrationForm_Form_CollectionType').val();
        let numberBinsCleaned = CountChecked();
        // Determine the base and default prices
        let basePrice = (cleaningFrequency === 'Monthly') ? 25.00 : 20.00;
        let defaultPrice = (cleaningFrequency === 'Monthly') ? 17.00 : 15.00;

        let totalAmount = 0.00;
        if(cleaningType === 'Subscription'){
            if (numberBinsCleaned > 1) {
                let extraBins = Math.max(0, numberBinsCleaned - 2); // Ensure no negative values
                let extraBinsAmount = 5 * extraBins;
                totalAmount = basePrice + extraBinsAmount;
            } else {
                totalAmount = defaultPrice;
            }
        }

        if(cleaningType === 'OneOff'){
            if (numberBinsCleaned > 1) {
                let extraBins = Math.max(0, numberBinsCleaned - 2); // Ensure no negative values
                let extraBinsAmount = 5 * extraBins;
                totalAmount = 25.00 + extraBinsAmount;
            } else {
                totalAmount = 20.00;
            }
        }


        // Return formatted amount as a string
        return '$' + totalAmount.toFixed(2);
    }

    function CountChecked(){
        let checked = 0;
        $('.which-bins-cleaned').each(function (f){
            if($(this).is(':checked')){
                checked = checked + 1;
            }
        });

        return checked;
    }



    $('#BinCleaningRegistrationForm_Form').on('submit', function(e){
        if(SearchAddress.val() !== '' && StreetAddress.val() === ''){
            SearchAddress.val('');
        }

        StreetAddressPrefilled();

        var formValid = $(this)[0].checkValidity();
        if (formValid) {
            $(this).addClass('was-validated');
            console.log('valid');
            console.log(paymentTypeOption.val());
            console.log($('#BinCleaningRegistrationForm_Form_PaymentMethodID').val());
            if(paymentTypeOption.val() === 'Credit Card' && $('#BinCleaningRegistrationForm_Form_PaymentMethodID').val() === ''){
                console.log('happening');
                e.preventDefault();
                stripe.confirmSetup({
                    elements,
                    redirect: 'if_required'
                }).then(function(result) {
                    if (result.error) {
                        if(result.error.code === 'setup_intent_unexpected_state'){
                            if(result.error.setup_intent){
                                $('#BinCleaningRegistrationForm_Form_PaymentMethodID').val(result.error.setup_intent.payment_method);
                                formItem.submit();
                            }
                        } else {
                            console.error('Error confirming setup:', result.error.message);
                            alert('Subscription failed: ' + result.error.message);
                        }

                    } else {
                        var paymentMethodId = result.setupIntent.payment_method;
                        $('#BinCleaningRegistrationForm_Form_PaymentMethodID').val(paymentMethodId);
                        formItem.submit();
                    }
                });
            }

        }
        if (formValid === false) {
            e.preventDefault();
            $(this).addClass('was-validated');
        }


    });

    StreetAddressPrefilled();

    $('.which-bins-cleaned').on('change',function(e){
        if(CheckIfAnyChecked()){
            ToggleRequired(false);
        } else {
            ToggleRequired(true);
        }
        AutomaticData();
    });

    FirstName.on('change',function(e){
        AutomaticData();
    });


    LastName.on('change',function(e){
        AutomaticData();
    });

    cleaningFrequency.on('change',function(e){
        AutomaticData();
    });

    function AutomaticData(){
        var webReference = LastName.val()+''+FirstName.val().charAt(0).toUpperCase();
        var total = totalPlusGst();
        automaticWebReferenceContent.text(webReference);
        automaticTotalContent.text(total);

    }

    function totalPlusGst() {
        let cleaningFrequency = $('#BinCleaningRegistrationForm_Form_CleaningFrequency').val();
        let cleaningType = $('#BinCleaningRegistrationForm_Form_CollectionType').val();
        let numberBinsCleaned = CountChecked();
        // Determine the base and default prices
        let basePrice = (cleaningFrequency === 'Monthly') ? 25.00 : 20.00;
        let defaultPrice = (cleaningFrequency === 'Monthly') ? 17.00 : 15.00;

        let totalAmount = 0.00;
        if(cleaningType === 'Subscription'){
            if (numberBinsCleaned > 1) {
                let extraBins = Math.max(0, numberBinsCleaned - 2); // Ensure no negative values
                let extraBinsAmount = 5 * extraBins;
                totalAmount = basePrice + extraBinsAmount;
            } else {
                totalAmount = defaultPrice;
            }
        }

        if(cleaningType === 'OneOff'){
            if (numberBinsCleaned > 1) {
                let extraBins = Math.max(0, numberBinsCleaned - 2); // Ensure no negative values
                let extraBinsAmount = 5 * extraBins;
                totalAmount = 25.00 + extraBinsAmount;
            } else {
                totalAmount = 20.00;
            }
        }


        // Return formatted amount as a string
        return '$' + totalAmount.toFixed(2);
    }

    function CheckIfAnyChecked(){
        let isChecked = false;
        $('.which-bins-cleaned').each(function (f){
            if($(this).is(':checked')){
                isChecked = true;
                return false;
            }
        });

        return isChecked;
    }

    function CountChecked(){
        let checked = 0;
        $('.which-bins-cleaned').each(function (f){
            if($(this).is(':checked')){
                checked = checked + 1;
            }
        });

        return checked;
    }

    function ToggleRequired(required){
        $('.which-bins-cleaned').each(function (f){
            if(required){
                $(this).attr('required','required');
            } else {
                $(this).removeAttr('required');
            }
        });
    }

    function StreetAddressPrefilled(){
        if(StreetAddress.val() !== ''){
            AutomaticAddress.addClass('d-none');
            ManualAddress.removeClass('d-none');
            ToggleButton.text('Search for address.');
            SearchAddress.removeAttr('required');
        }
    }


    ToggleButton.on('click',function (e){
        e.preventDefault();
        if(AutomaticAddress.hasClass('d-none')){
            ManualAddress.addClass('d-none');
            AutomaticAddress.removeClass('d-none');
            ToggleButton.text('Enter address manually.');
            ToggleButtonText.removeClass('d-none');
            SearchAddress.attr('required','required');
        } else {
            AutomaticAddress.addClass('d-none');
            ManualAddress.removeClass('d-none');
            ToggleButton.text('Search for address.');
            ToggleButtonText.addClass('d-none');
            SearchAddress.removeAttr('required');
        }
        return false;
    });

    TypeInput.on('change',function (e){
        e.preventDefault();
        let subscriptionValue = $(this).val();
        if(subscriptionValue === 'Subscription'){
            SubscriptionWrapper.removeClass('d-none');
            CollectionWrapper.removeClass('d-none');
            populateSubscriptionStartDates();
        } else if (subscriptionValue === 'OneOff') {
            SubscriptionWrapper.addClass('d-none');
            CollectionWrapper.removeClass('d-none');
            populateOneOffStartDates();
        } else {
            SubscriptionWrapper.addClass('d-none');
            CollectionWrapper.addClass('d-none');
        }
        AutomaticData();
        return false;
    });

    CollectionDay.on('change',function (e){
        console.log('hello')
        e.preventDefault();
        let subscriptionValue = $(this).val();
        console.log(subscriptionValue)
        if(TypeInput.val() === 'Subscription'){
            console.log('hello')
            populateSubscriptionStartDates();
        } else if (TypeInput.val() === 'OneOff') {
            populateOneOffStartDates();
        } else {
        }
        return false;
    });

    function emptyOutDates(){
        $('#BinCleaningRegistrationForm_Form_StartDate').find('option:not([value=""])').remove();
    }

    function populateSubscriptionStartDates(){
        emptyOutDates();
        if(CollectionDay.val() !== ''){
            let dates = getNext4Dates(CollectionDay.val());
            dates.forEach(date => {
                $('#BinCleaningRegistrationForm_Form_StartDate').append(`<option value="${date.value}">${date.text}</option>`);
            });
        }
    }

    $('#BinCleaningRegistrationForm_Form_StartDate').on('change',function(){
        console.log($(this).val())
    })


    function populateOneOffStartDates(){
        emptyOutDates();
        let dates = get30Dates();
        dates.forEach(date => {
            $('#BinCleaningRegistrationForm_Form_StartDate').append(`<option value="${date.value}">${date.text}</option>`);
        });
    }

    function getNext4Dates(targetDay) {
        const targetDayNumber = {
            Monday: 1,
            Tuesday: 2,
            Wednesday: 3,
            Thursday: 4,
            Friday: 5,
            Saturday: 6,
            Sunday: 7
        }[targetDay];

        if (!targetDayNumber) {
            throw new Error("Invalid day chosen. Use Monday, Tuesday, etc.");
        }

        let nextDates = [];
        let currentDate = moment();

        if (currentDate.isoWeekday() === targetDayNumber) {
            currentDate.add(7, 'days'); // Skip today by jumping to next week's target day
        } else {
            // Move to the next target day within the current week
            currentDate.isoWeekday(targetDayNumber);
        }

        // Get the next 4 target days
        for (let i = 0; i < 6; i++) {
            nextDates.push({
                value: currentDate.format('YYYY-MM-DD'), // Raw date
                text: currentDate.format('dddd, MMMM Do YYYY') // Human-readable text
            });
            currentDate.add(7, 'days'); // Move to the same day next week
        }

        return nextDates;
    }

    function get30Dates() {
        const today = moment(); // Get today's date
        const next30Days = [];

        for (let i = 1; i < 14; i++) {
            const currentDate = today.clone().add(i, 'days'); // Add i days to today
            next30Days.push({
                value: currentDate.format('YYYY-MM-DD'), // Raw date
                text: currentDate.format('dddd, MMMM Do YYYY') // Human-readable text
            });
        }

        return next30Days;
    }

}
